import React, { useState } from 'react';
import {
  ErrorText,
  PlanHeader,
  PlanFooter,
  PlanBody,
  Price,
  FieldsContainer,
  PlanLabel,
  BlockContainer,
  FlexContainer,
  CheckboxContainer,
  CourseContainer,
} from './styles';
import { Button } from 'components/Button/RoundButton';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { OuterContainer, SectionTitle, TextInput } from '../styles';

export default function CoursePricePlans({ courses, updateCourse }) {
  const [error, setError] = useState('');
  const [course, setCourse] = useState({});
  const [showUpdatePlanForm, setShowUpdatePlanForm] = useState(false);

  const validateAndUpdateCourse = () => {
    if (!course.name.trim()) return setError('Name field is mandatory');
    if (
      course.isPaidCourse &&
      (!course.price.actualPrice['EUR'] ||
        !course.price.actualPrice['SEK'] ||
        !course.price.actualPrice['USD'] ||
        !course.price.discountPrice['EUR'] ||
        !course.price.discountPrice['SEK'] ||
        !course.price.discountPrice['USD'])
    )
      return setError('All fields are mandatory');

    updateCourse(course._id, {
      name: course.name,
      price: course.price,
      isPaidCourse: course.isPaidCourse ?? false,
    });
    setError('');
    setShowUpdatePlanForm(false);
  };

  const updateCoursePlanPrice = (currency, priceType, value) => {
    setCourse((prevCoursePlan) => ({
      ...prevCoursePlan,
      price: {
        ...prevCoursePlan.price,
        [priceType]: {
          ...prevCoursePlan.price[priceType],
          [currency]: value,
        },
      },
    }));
  };

  const renderUpdatePlanForm = () => {
    return (
      <>
        <FieldsContainer>
          <BlockContainer>
            <PlanLabel>Name</PlanLabel>
            <TextInput
              type="text"
              padding="5px"
              margin="0px"
              height="30px"
              onChange={(e) => setCourse({ ...course, name: e.target.value })}
              placeholder="Name*"
              value={course.name}
            />
          </BlockContainer>
          <CheckboxContainer>
            <Checkbox
              checked={course.isPaidCourse}
              label="Is paid course"
              onChange={() => setCourse({ ...course, isPaidCourse: !course.isPaidCourse })}
            />
          </CheckboxContainer>
          {course.isPaidCourse && (
            <>
              <BlockContainer>
                <PlanLabel>Actual Price (SEK)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('SEK', 'actualPrice', e.target.value)}
                  placeholder="SEK*"
                  value={course.price.actualPrice['SEK']}
                />
              </BlockContainer>
              <BlockContainer>
                <PlanLabel>Discount Price (SEK)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('SEK', 'discountPrice', e.target.value)}
                  placeholder="SEK*"
                  value={course.price.discountPrice['SEK']}
                />
              </BlockContainer>
              <BlockContainer>
                <PlanLabel>Actual Price (EUR)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('EUR', 'actualPrice', e.target.value)}
                  placeholder="EUR*"
                  value={course.price.actualPrice['EUR']}
                />
              </BlockContainer>
              <BlockContainer>
                <PlanLabel>Discount Price (EUR)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('EUR', 'discountPrice', e.target.value)}
                  placeholder="EUR*"
                  value={course.price.discountPrice['EUR']}
                />
              </BlockContainer>
              <BlockContainer>
                <PlanLabel>Actual Price (USD)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('USD', 'actualPrice', e.target.value)}
                  placeholder="USD*"
                  value={course.price.actualPrice['USD']}
                />
              </BlockContainer>
              <BlockContainer>
                <PlanLabel>Discount Price (USD)*</PlanLabel>
                <TextInput
                  type="number"
                  padding="5px"
                  margin="0px"
                  height="30px"
                  onChange={(e) => updateCoursePlanPrice('USD', 'discountPrice', e.target.value)}
                  placeholder="USD*"
                  value={course.price.discountPrice['USD']}
                />
              </BlockContainer>
            </>
          )}
        </FieldsContainer>
        {error && <ErrorText>{error}</ErrorText>}
        <Button small primaryBlue primaryGreenBorder margin="15px 0 0 0" onClick={() => validateAndUpdateCourse()}>
          Update
        </Button>
      </>
    );
  };

  return (
    <OuterContainer>
      <SectionTitle>Course Price Plans</SectionTitle>
      {showUpdatePlanForm && renderUpdatePlanForm()}
      <FlexContainer gap="20">
        {!showUpdatePlanForm &&
          courses?.map((course) => (
            <CourseContainer key={course._id}>
              <PlanHeader>{course.name}</PlanHeader>
              <PlanBody>
                {course.isPaidCourse &&
                  Object.keys(course.price.actualPrice).map((key) => (
                    <React.Fragment key={key}>
                      Actual {key} Price <Price>{course.price.actualPrice[key]}</Price>
                      Discount {key} Price <Price>{course.price.discountPrice[key]}</Price>
                    </React.Fragment>
                  ))}
                {!course.isPaidCourse && <Price>Free</Price>}
              </PlanBody>
              <PlanFooter>
                <Button
                  small
                  primaryBlue
                  primaryGreenBorder
                  removeMargin
                  onClick={() => {
                    setCourse(course);
                    setShowUpdatePlanForm(true);
                  }}
                >
                  Update
                </Button>
              </PlanFooter>
            </CourseContainer>
          ))}
      </FlexContainer>
    </OuterContainer>
  );
}
